import RootLayout from "./layouts/root-layout";
import Loader from "./app/common/loader";
import ScrollToTop from "./globals/scroll-to-top";
import { AuthProvider } from "./contexts/AuthContext";
import { WebSocketProvider } from "./contexts/WebSocketContext";
import GlobalPopupProvider from "./components/GlobalPopupProvider";
import CandidateInterviewReminder from "./components/CandidateInterviewReminder";
import { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import forceLightMode from "./utils/forceLightMode";
// CONSOLIDATED MASTER STYLES - All CSS in one file to eliminate cascade conflicts
import "./consolidated-master-styles.css";
import "./home-job-cards.css";
// CARD STYLES PRESERVATION - Ensures card styles remain intact after hosting
import "./card-styles-preserve.css";
// REMOVE BUTTON HOVER EFFECTS - No color changes on hover
import "./remove-button-hover-effects.css";
// REMOVE RESUME CARD HOVER EFFECTS - No hover effects on resume page cards
import "./remove-resume-card-hover.css";
// TAB ICON FIX - Remove orange color from tab icons
import "./tab-icon-fix.css";
// SCROLL LOCK STYLES - Disable background scrolling when modals are open
import "./styles/scroll-lock.css";
// CANDIDATE HEADER MOBILE FIX - Fix header display on mobile screens
import "./header-styles.css";
// ENHANCED MOBILE RESPONSIVE - Comprehensive mobile fixes for all pages
import "./mobile-responsive-enhancements.css";
// MOBILE RESPONSIVE FIXES - Targeted fixes for specific alignment issues
import "./mobile-responsive-fixes.css";
// CANDIDATE PANEL RESPONSIVE - Shared mobile/tablet fixes for candidate-side pages
import "./candidate-panel-responsive.css";
// EMPLOYER PANEL RESPONSIVE - Shared mobile/tablet fixes for employer-side pages
import "./employer-panel-responsive.css";
// BADGE TEXT ORANGE - Make all status badge texts orange
import "./badge-text-orange.css";
// GLOBAL Z-INDEX FIX - Comprehensive fix for all stacking issues
import "./global-zindex-fix.css";
// iOS HAMBURGER ULTIMATE PRODUCTION FIX - Final solution for iPhone visibility issues
import "./iphone-hamburger-ultimate-production-fix.css";
// ANDROID HAMBURGER FIX - Addresses visibility issues on Android mobile browsers
import "./android-hamburger-fix.css";
// POPUP SCROLL FIX - Ensures whole modal scrolls naturally
import "./popup-scroll-fix.css";
// ANDROID TEXT OVERFLOW FIX - Prevents text from overflowing cards on Android devices
import "./android-text-overflow-fix.css";
// CONDITION BADGE MOBILE FIX - Fixes condition badge text overflow on mobile screens
import "./condition-badge-mobile-fix.css";
// GLOBAL TABLE RESPONSIVE FIX - Ensures all tables fit container with horizontal scroll
import "./table-overflow-fix.css";
// GIF ALIGNMENT REVERT - Fixes alignment issues caused by adding GIF logos
import "./gif-alignment-revert.css";
// HERO SECTION REVERT - Reverts Hero section layout to original appearance
import "./hero-section-revert.css";
// RICH TEXT EDITOR TEXT BLACK - Ensures Rich Text Editor text is black, not orange
import "./rich-text-editor-text-black.css";
// SHARED PANEL TOOLBARS - Align title/search/filter rows across admin, employer, and candidate pages
import "./shared-page-toolbar.css";
// SHARED TITLE CASE - Keep internal panel labels and titles in Title Case
import "./title-case-platform.css";
// ABOUT PAGE BANNER FIX - Reduce top banner space on About Us page only
import "./about-page-banner-fix.css";
// CREATE PASSWORD BANNER FIX - Reduce top banner space on create-password page only
import "./create-password-banner-fix.css";
// MOBILE CLICKABILITY FIX - restore taps after broad mobile CSS overrides
import "./mobile-clickability-fix.css";
// PANEL MOBILE OVERFLOW GUARD - final mobile text wrapping protection for candidate/employer panel pages
import "./panel-mobile-overflow-guard.css";
// HAMBURGER NO OVERFLOW - final drawer viewport containment guard
import "./hamburger-no-overflow-fix.css";


function App() {

  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    // Show message if redirected after forced logout due to password change
    const params = new URLSearchParams(window.location.search);
    if (params.get('session_expired') === 'password_changed') {
      setTimeout(() => {
        alert('Your password was changed on another device. Please log in again.');
      }, 500);
      // Clean the URL without reloading
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
    }
  }, []);

  useEffect(() => {
    // Force light mode immediately
    const cleanup = forceLightMode();

    const timer = setTimeout(() => {
      setLoading(false);
    }, 50);

    // Defer AOS init until after first paint to avoid blocking main thread
    const initAOS = () => AOS.init({ duration: 300, once: true, offset: 50 });
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(initAOS);
    } else {
      setTimeout(initAOS, 200);
    }
    
    return () => {
      clearTimeout(timer);
      cleanup();
    };
  }, []);

  return (
    <AuthProvider>
      <WebSocketProvider>
        <GlobalPopupProvider>
          {isLoading && <Loader />}
          <ScrollToTop />
          <CandidateInterviewReminder />
          <RootLayout />
        </GlobalPopupProvider>
      </WebSocketProvider>
    </AuthProvider>
  )
}

export default App;
